import { FC } from 'react';

import { ChildrenPropType } from 'src/utils/types';
import { ScreenType } from 'src/components/Modals/TemplateGallery/index';
import styles from 'src/styles/common/templateGallery.module.scss';
import { TemplateGalleryRocketIcon } from 'src/components/Modals/TemplateGallery/icons/Rocket';
import { TemplateGalleryLayoutIcon } from 'src/components/Modals/TemplateGallery/icons/Layout';

type Props = {
  children: ChildrenPropType;
  screen: Extract<ScreenType, 'main' | 'all'>;
};

export const TemplateGalleryTitle: FC<Props> = ({ children, screen }) => {
  const Icon = screen === 'main' ? TemplateGalleryRocketIcon : TemplateGalleryLayoutIcon;

  return (
    <div className={styles.title}>
      <Icon className={styles.titleIcon} />
      <span>{children}</span>
    </div>
  );
};
